import React from "react";
import styled, { keyframes } from "styled-components";

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

const StyledSvg = styled.svg`
  animation: ${rotate} 1s linear infinite;
  width: 20px;
  height: 20px;
`;

const LoadingIcon = () => (
  <StyledSvg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4.77246 6.63133C5.19236 6.0582 5.68091 5.5388 6.22419 5.0791"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.3229 9.5459C3.06022 10.5091 2.94579 11.528 3.0244 12.5797"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.84791 19.3612C5.4917 18.4239 4.40613 17.1174 3.72852 15.5791"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.5595 19.0859C16.2033 20.1486 14.5286 20.8362 12.6809 20.9745C11.7704 21.0421 10.8829 20.9705 10.0371 20.7805"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.6407 16.7241C20.5501 15.2555 21.0576 13.5192 20.9859 11.6635C20.7949 6.69133 16.6098 2.81573 11.6367 3.00677"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </StyledSvg>
);

export default LoadingIcon;
